module.exports = __webpack_public_path__ + "static/media/shequ1.aeb3965f.jpg";